/**
 * 프로젝트 업로드 관련 상수 정의
 */ // 파일 타입 관련 상수
export var FILE_TYPES = {
    // ZIP 파일 관련
    ZIP_MIME_TYPES: [
        'application/zip',
        'application/x-zip-compressed'
    ],
    ZIP_EXTENSIONS: [
        '.zip'
    ],
    // 미디어 파일 관련
    MEDIA_MIME_TYPES: [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'video/mp4',
        'video/webm'
    ],
    // 필수 프로젝트 파일들
    REQUIRED_FILES: [
        'package.json',
        'pnpm-lock.yaml',
        'vite.config'
    ]
};
// 파일 크기 제한 (bytes)
export var FILE_SIZE_LIMITS = {
    MAX_ZIP_SIZE: 100 * 1024 * 1024,
    MAX_MEDIA_SIZE: 50 * 1024 * 1024
};
// 메시지 상수
export var MESSAGES = {
    // 성공 메시지
    SUCCESS: {
        ZIP_ANALYSIS_COMPLETE: 'ZIP 파일 분석이 완료되었습니다.',
        PROJECT_SAVED: '프로젝트가 성공적으로 저장되었습니다.',
        FILES_UPLOADED: function(count) {
            return "".concat(count, "개 파일이 업로드 되었습니다.");
        },
        VALIDATION_SUCCESS: '✅ 필요한 설정 파일(package.json, pnpm-lock.yaml, vite.config)이 확인되었습니다.'
    },
    // 경고 메시지
    WARNING: {
        LARGE_FOLDER: '매우 큰 폴더(특히 node_modules 포함 시)는 브라우저 제한으로 업로드가 실패할 수 있습니다. 이 경우 node_modules를 제외하고 폴더를 업로드하거나, 아래 ZIP 파일 업로드 옵션을 사용해 주세요.',
        MISSING_FILES: function(files) {
            return "다음 필수 파일이 누락되었습니다: ".concat(files.join(', '), ". WebContainer 실행에 문제가 발생할 수 있습니다.");
        },
        UPLOAD_IN_PROGRESS: '파일 업로드가 진행 중입니다. 잠시 후 다시 시도해주세요.',
        NO_PROJECT_FILES: '프로젝트 파일(폴더 또는 ZIP)을 업로드해주세요.'
    },
    // 에러 메시지
    ERROR: {
        INVALID_ZIP_FORMAT: '⚠️ .zip 확장자 파일만 업로드할 수 있습니다.',
        ZIP_PROCESSING_FAILED: 'ZIP 파일을 처리하는 중 오류가 발생했습니다.',
        NO_PROJECT_FILES_TO_UPLOAD: '업로드할 프로젝트 파일이 없습니다.',
        PROJECT_SAVE_FAILED: function(detail) {
            return detail || '프로젝트 저장 중 알 수 없는 오류가 발생했습니다.';
        }
    },
    // 진행 상태 메시지
    PROGRESS: {
        ZIP_ANALYZING: 'ZIP 파일 분석 중...',
        PROJECT_COMPRESSING: '프로젝트 파일 압축 중...',
        ZIP_UPLOADING: 'ZIP 파일 업로드 중...',
        PROJECT_UPLOADING: '프로젝트 업로드 중...',
        SAVING: '저장 중...'
    }
};
// UI 관련 상수
export var UI_CONSTANTS = {
    // 버튼 텍스트
    BUTTONS: {
        FOLDER_UPLOAD: '폴더 업로드',
        ZIP_UPLOAD: 'ZIP 파일 업로드',
        PROJECT_SAVE: '프로젝트 저장',
        CANCEL: '취소',
        GO_BACK: '뒤로가기'
    },
    // 섹션 제목
    SECTIONS: {
        PROJECT_INFO: '프로젝트 정보',
        PROJECT_MEDIA: '프로젝트 대표 이미지',
        PROJECT_FILES: '프로젝트 파일',
        ZIP_FILE_STRUCTURE: 'ZIP 파일 구조'
    },
    // 페이지 제목
    PAGE_TITLES: {
        NEW_PROJECT: '새 프로젝트 정보 입력',
        EDIT_PROJECT: '프로젝트 수정'
    }
};
// 웹 디렉토리 업로드 속성
export var DIRECTORY_UPLOAD_PROPS = {
    webkitdirectory: "true",
    directory: "true"
};
